import React from "react";
import { Button } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";

const RefreshButton = ({ onClick, icon: Icon = RefreshIcon, label, sx, ...props }) => {
  return (
    <Button
      variant="contained"
      color="primary"
      size="small"
      sx={{
        backgroundColor: "#F13131",
        "&:hover": {
          backgroundColor: "#d32f2f", // Darker red for hover state
        },
        ...sx, // Spread to allow custom styling overrides
      }}
      onClick={onClick}
      {...props} // Spread other props like type, disabled, etc.
    >
      {Icon && <Icon />} {/* Show icon if provided */}
    </Button>
  );
};

export default RefreshButton;
